<div class="d-flex align-items-center gap-2 mb-4">

    @for (link of linkMap; track $index) {
        <div class="d-flex align-items-center gap-2">
            @if (link.icon) {
                <lucide-icon color="#b1b3b6" [name]="link.icon" size="18"></lucide-icon>
            }
            <span> {{(link.name | translate)}}</span>
        </div>
        @if ($index < linkMap.length - 1) {
            <lucide-icon color="#b1b3b6" [name]=" languageService.selectedLanguage=='ar' ? 'chevron-left' : 'chevron-right'" size="18"></lucide-icon>
        }
    }

</div>